import content from '../content.json';
const pub = process.env.PUBLIC_URL;

export default function Footer() {
  const f = content.footer;
  const links = [
    { label: 'Home', href: '/' },
    { label: 'The Project', href: '/project' },
    { label: 'Rooms', href: '/#rooms' },
    { label: 'Experience', href: '/#experiences' },
  ];

  return (
    <footer id="contact" style={{ background: 'var(--black)', borderTop: '1px solid rgba(200,150,60,0.12)', padding: '72px 0 28px' }}>
      <div style={{ maxWidth: '1160px', margin: '0 auto', padding: '0 48px' }}>
        <div style={{ display:'grid',gridTemplateColumns:'2fr 1fr 1fr',gap:'60px',marginBottom:'56px' }}>
          <div>
            <img src={`${pub}/logo.png`} alt="Silverkammer" style={{ height:'48px',width:'auto',marginBottom:'20px' }} />
            <p style={{ fontFamily:'var(--font-body)',fontSize:'12px',lineHeight:1.8,color:'rgba(248,245,240,0.4)',maxWidth:'280px',marginBottom:'20px' }}>Urban Retreat & Design Gallery.<br/>A design loft in a historic silversmith factory.<br/>Florence, Italy.</p>
            <a href={`mailto:${f.email}`} style={{ fontFamily:'var(--font-body)',fontSize:'12px',color:'var(--gold)',transition:'opacity 0.2s' }} onMouseEnter={e=>e.target.style.opacity='0.7'} onMouseLeave={e=>e.target.style.opacity='1'}>{f.email}</a>
          </div>
          <div>
            <p style={{ fontFamily:'var(--font-body)',fontSize:'10px',letterSpacing:'0.28em',textTransform:'uppercase',color:'var(--gold)',marginBottom:'20px' }}>Quick Links</p>
            <div style={{ display:'flex',flexDirection:'column',gap:'10px' }}>
              {links.map((l,i) => (
                <a key={i} href={l.href} style={{ fontFamily:'var(--font-body)',fontSize:'13px',color:'rgba(248,245,240,0.45)',transition:'color 0.2s' }} onMouseEnter={e=>e.target.style.color='var(--offwhite)'} onMouseLeave={e=>e.target.style.color='rgba(248,245,240,0.45)'}>{l.label}</a>
              ))}
            </div>
          </div>
          <div>
            <p style={{ fontFamily:'var(--font-body)',fontSize:'10px',letterSpacing:'0.28em',textTransform:'uppercase',color:'var(--gold)',marginBottom:'20px' }}>Contact Info</p>
            <div style={{ display:'flex',flexDirection:'column',gap:'10px' }}>
              <a href={`mailto:${f.email}`} style={{ fontFamily:'var(--font-body)',fontSize:'13px',color:'rgba(248,245,240,0.45)',transition:'color 0.2s' }} onMouseEnter={e=>e.target.style.color='var(--offwhite)'} onMouseLeave={e=>e.target.style.color='rgba(248,245,240,0.45)'}>{f.email}</a>
              <a href="/project" style={{ fontFamily:'var(--font-body)',fontSize:'13px',color:'rgba(248,245,240,0.45)',transition:'color 0.2s' }} onMouseEnter={e=>e.target.style.color='var(--offwhite)'} onMouseLeave={e=>e.target.style.color='rgba(248,245,240,0.45)'}>About us</a>
              <a href="/privacy" style={{ fontFamily:'var(--font-body)',fontSize:'13px',color:'rgba(248,245,240,0.45)',transition:'color 0.2s' }} onMouseEnter={e=>e.target.style.color='var(--offwhite)'} onMouseLeave={e=>e.target.style.color='rgba(248,245,240,0.45)'}>Privacy Policy</a>
            </div>
          </div>
        </div>
        <div style={{ borderTop:'1px solid rgba(200,150,60,0.1)',paddingTop:'20px',display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:'12px' }}>
          <span style={{ fontFamily:'var(--font-body)',fontSize:'11px',color:'rgba(248,245,240,0.2)' }}>{f.copyright}</span>
          <span style={{ fontFamily:'var(--font-title)',fontStyle:'italic',fontSize:'12px',color:'rgba(200,150,60,0.25)' }}>The silverware factory met a wunderkammer.</span>
        </div>
      </div>
    </footer>
  );
}
